<template>
  <div>
    <CustomerCreate v-model="form" :initialData="initialData" :isParentLocked="isLocked" :isRemoteControlled="true"></CustomerCreate>
    <ServiceRequestCreate ref="serviceRequestCreate" :initialID="ID" :policy="policy" :serviceRequestType="serviceRequestKey" @onLockedChanged="onLockedChanged" @onDataRetrived="onDataRetrived">
      <div slot="serviceRequestType" slot-scope="row">
      </div>
    </ServiceRequestCreate>
  </div>
</template>
<script type="text/javascript">
import ServiceRequestCreate from '../ServiceRequestCreate'

import {
  FITTextInput,
  FITButton,
  FITAutoSearch,
  FITSelect,
  FITTextarea,
  FITDatePicker
} from '@/components'

import { CustomerCreate } from '@/Crm/components/Customer'

import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'
export default {
  name: 'ChangePersonalInformation',
  components: {
    ServiceRequestCreate,
    FITTextInput,
    FITButton,
    FITAutoSearch,
    FITSelect,
    FITDatePicker,
    FITTextarea,
    CustomerCreate
  },

  methods: {
    getLabel(field) {
      return this.$t(`osm.serviceRequest.type.${this.serviceRequestKey}.${field}`);
    }
  },

  data() {
    return {
      type: {},
      form: {},
      initialData: {},
      serviceRequestKey: 'CPI',
      isLocked: false
    }
  },

  props: {
    ID: {
      type: Number,
      default: null
    },

    policy: {
      type: Object,
      default: null
    }
  },

  methods: {
    onLockedChanged(val) {
      Vue.set(this, 'isLocked', val)
    },

    onDataRetrived(val) {
      Vue.set(this, 'initialData', val);
      Vue.set(this, 'form', val);
    }
  },

  computed: {
    columnWidth() {
      if (this.$refs.serviceRequestCreate) {
        return this.$refs.serviceRequestCreate.option.data.column;
      }
      return 10;
    },

    ...mapGetters('ServiceRequest', [
      'getTranslated',
      'getTranslatedArray',
      'getTranslatedString',
      'isValueModified',
      'getServiceRequestTranslated'
    ]),

    ...mapState('ServiceRequest', [
      'fields',
      'selectedType',
    ]),
  },

  created() {
    if (!this.policy) {
      console.debug(this.serviceRequestKey, 'Null policy ID when routing to service request');
      return
    }

    this.$store.commit({ type: 'ServiceRequest/setServiceRequestType', serviceRequestType: this.serviceRequestKey });

    // Current Data
    // this.$store.dispatch('ServiceRequest/getFields', {
    //     type: this.serviceRequestKey,
    //     ...this.policy
    //   })
    //   .then((json) => {
    //     this.selectedType.list
    //       .forEach((column) => {
    //         Vue.set(this.form, column.fieldColumn, this.selectedType.data[column.fieldColumn])
    //       })
    //     Vue.set(this, 'initialData', json.data);
    //   })
    //   .catch((err) => {

    //   })
  },

  watch: {
    form: {
      deep: true,
      handler(val) {
        this.$store.commit({
          type: 'ServiceRequest/setTypeForm',
          form: JSON.parse(JSON.stringify(val))
        })
      }
    }
  }

}

</script>



// WEBPACK FOOTER //
// src/Osm/ServiceRequest/components/ServiceRequestTypes/ChangePersonalInformation.vue